:root {
  --g-top-bar-height: 48px;
  --g-mobile-top: 59px;
  --g-mobile-bottom: 94px;
  --g-mobile-preview-max-height: 512px; }

._previewContainer_1tsbw_7 {
  -webkit-user-select: none;
  user-select: none;
  overflow-y: scroll;
  position: relative;
  width: 100%;
  height: 100%; }
  ._previewContainer_1tsbw_7._truncated_1tsbw_16 {
    overflow-y: hidden; }
  ._previewContainer_1tsbw_7._fixed_1tsbw_18 {
    overflow-x: hidden; }
    ._previewContainer_1tsbw_7._fixed_1tsbw_18 ._previewPlaceholder_1tsbw_20 {
      width: var(--stage-fixed-width); }
  ._previewContainer_1tsbw_7._previewMode_1tsbw_22 {
    overflow: hidden; }
  ._previewContainer_1tsbw_7._resizablePreviewMode_1tsbw_24 {
    margin: 0 var(--preview-horizontal-margin);
    flex-shrink: 0;
    width: calc(var(--preview-width) * var(--site-scale));
    box-shadow: 0px 12px 20px 0px rgba(23, 25, 28, 0.12); }
    ._previewContainer_1tsbw_7._resizablePreviewMode_1tsbw_24 ._previewPlaceholder_1tsbw_20 {
      width: calc(var(--preview-width) * var(--site-scale)); }
    ._previewContainer_1tsbw_7._resizablePreviewMode_1tsbw_24._mobile_1tsbw_31 {
      box-shadow: none;
      width: 100%;
      animation: _fade-in_1tsbw_1 linear 0.4s;
      transition: none; }
      ._previewContainer_1tsbw_7._resizablePreviewMode_1tsbw_24._mobile_1tsbw_31 ._previewPlaceholder_1tsbw_20 {
        width: 100%; }
  ._previewContainer_1tsbw_7._mobile_1tsbw_31._mobileWizard_1tsbw_38 {
    overflow: hidden; }
  ._previewContainer_1tsbw_7._animatePreviewWidth_1tsbw_40 {
    transition: width 0.33s cubic-bezier(0.45, 0, 0.55, 1), margin 0.33s cubic-bezier(0.45, 0, 0.55, 1), height 0.33s cubic-bezier(0.45, 0, 0.55, 1); }
    ._previewContainer_1tsbw_7._animatePreviewWidth_1tsbw_40 ._previewPlaceholder_1tsbw_20 {
      transition: width 0.33s cubic-bezier(0.45, 0, 0.55, 1), height 0.33s cubic-bezier(0.45, 0, 0.55, 1); }
  ._previewContainer_1tsbw_7 ._mobileHidePreviewLeft_1tsbw_44,
  ._previewContainer_1tsbw_7 ._mobileHidePreviewRight_1tsbw_45 {
    display: block;
    position: absolute;
    top: 0;
    height: 100%; }
  ._previewContainer_1tsbw_7 ._mobileHidePreviewLeft_1tsbw_44 {
    left: 0; }

._previewPlaceholder_1tsbw_20 {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  border: 0;
  overflow: hidden; }
